import * as React from "react"
import { App } from "./app"
import { BDKalkCore } from "./BDKalkCore"

///////////////   NewProjectView  ////////////////

/* NewProjectView helps the user to open a new project. */

export interface NewProjectViewVm  {
    app: App
}

export interface NewProjectViewStateVm {
    stage: string
}

export class NewProjectView extends React.Component<NewProjectViewVm, NewProjectViewStateVm> {

    constructor(props: NewProjectViewVm) {
        super(props)
   }

    // 
    state = {
        stage: "initial"
    }

    // 
    componentWillMount() {
        this.props.app.GetCore().ConnectNewProjectView(this)
    }

    /* 
                        <div>Vis du ønsker å åpne nåvarende utvalg igjen senere</div>
                        <div>må du først lagre det. Er du sikker på at du ønsker</div>
                        <div>å nullstille nåvarende utvalg og lage et nytt?</div>
    */
    
    // 
    render() {
        const core = this.props.app.GetCore() 
        
        if (this.state.stage == "initial") {
            if ((this.props.app.GetCore().GetSelectedArticles().length > 0) || (this.props.app.GetCore().GetSelectedBuildParts().length > 0)) {

                return <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "calc(50% - 130px)", height: "1px" }}>
                    </div>
                    <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column" }}>
                        <div>Ønsker du å lagre endringerne på nåvarende utvalg før du lager et nytt?</div>

                        <div style={{ position: "relative", top: "5px", display: "flex", flexDirection: "row" }}>
                            <div onClick={this.OnSaveFirst.bind(this)} style={{ backgroundColor: "grey", width: "125px", height: "30px", position: "relative", top: "20px", cursor: "pointer" }}>
                                <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                    Lagre endringer
                                </div>
                            </div>

                            <div onClick={this.OnDeleteSure.bind(this)} style={{ backgroundColor: "grey", width: "145px", height: "30px", position: "relative", top: "20px", left: "20px", cursor: "pointer" }}>
                                <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                    Ikke lagre endringer
                                </div>
                            </div>

                            <div onClick={this.OnCansel.bind(this)} style={{ backgroundColor: "grey", width: "74px", height: "30px", position: "relative", top: "20px", left: "40px", cursor: "pointer" }}>
                                <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                    Avbryt
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            }
            else {
                return <div style={{ marginLeft: "20px", marginTop: "20px"}}> Et nytt utvalg er lagd.
                </div>
            }
        }

        if (this.state.stage == "saved") {
            return <div style={{ marginLeft: "20px", marginTop: "20px" }}> Utvalget er nå lagret og et nytt utvalg er skapt.
            </div>
        }
        
        if (this.state.stage == "performed") {
            return <div style={{ marginLeft: "20px", marginTop: "20px" }}> Nullstillingen av utvalg er nå foretatt.
            </div>
        }

        if (this.state.stage == "cancelled") {
            return <div style={{ marginLeft: "20px", marginTop:"20px" }}>Nullstillingen av utvalg er avbrutt.
            </div>
        }

        return <div></div>
    }
    
    OnSaveFirst() {
        this.props.app.GetCore().GetSelectionSetManager().SaveProject(this.props.app.GetCore().GetSelectionSetManager().GetCurrentProjectName(), null)
        this.props.app.GetCore().ClearAllQRArticles()
        this.props.app.GetCore().ClearAllQRBuildParts()
        this.props.app.GetCore().GetSelectionSetManager().SetCurrentProjectNameToNew()
        this.setState({ stage: "saved" })
    }
    
    OnDeleteSure() {
        this.props.app.GetCore().ClearAllQRArticles()
        this.props.app.GetCore().ClearAllQRBuildParts()
        this.props.app.GetCore().GetSelectionSetManager().SetCurrentProjectNameToNew()
        this.setState({stage : "performed"})
    }

    OnCansel() {
        this.setState({ stage:"cancelled"})
    }
    
    m_hoveredItem: number
}


// WEBPACK FOOTER //
// ./client/view/NewProjectView.tsx